import Axios from 'axios';

export const signInUserWithEmailPasswordRequest = ({username, password, userId, isOtp, isResendOtp, otp, token}) => {
    return Axios({
        method: 'post',
        url: window.ApiURL + 'authentication/user/create',
        data: {
            deviceUniqueId: 'Portal',
            username: username,
            password: password,
            userId: userId,
            isOtp: isOtp,
            isResendOtp: isResendOtp,
            otp: otp,
            token: token
        },
        headers:{
            'Content-Type': 'application/json'
        }
    });
};

export const forgotPasswordApi = ({username}) => {
    return Axios({
        method: 'post',
        url: window.ApiURL + 'merchant/password/forgot',
        data: {
            username: username,        },
        headers:{
            'Content-Type': 'application/json'
        }
    });
};

export const changePasswordApi = ({authToken, deviceId, userId, merchantId, password}) => {
    return Axios({
        method: 'post',
        url: window.ApiURL + 'merchant/password/change',
        data: {
            userId: userId,
            merchantId: merchantId,
	        password : password
        },
        headers:{
            'Content-Type': 'application/json',
            'authToken': authToken,
            'deviceUniqueId' : deviceId,
        }
    });
};
